import { render, staticRenderFns } from "./BaseButtton.vue?vue&type=template&id=3c01178a&scoped=true"
import script from "./BaseButtton.vue?vue&type=script&lang=js"
export * from "./BaseButtton.vue?vue&type=script&lang=js"
import style0 from "./BaseButtton.vue?vue&type=style&index=0&id=3c01178a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c01178a",
  null
  
)

export default component.exports